module.exports = __webpack_public_path__ + "img/film-simple.38659236.svg";